import { render, staticRenderFns } from "./projectSideView.vue?vue&type=template&id=6c7533dc"
import script from "./projectSideView.vue?vue&type=script&lang=js"
export * from "./projectSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports